<template>
	<component :is="name" :dataQuery="dataQuery">
	</component>
</template>

<script>
  import MarketAnalysis from '@/modules/neodash/containers/market-analysis/index.vue';

  import {momentMixin} from '@/modules/neodash/mixins';

  import {FILTERS_GET_VALUES} from '@/modules/neodash/store/modules/filters/types';
  import {mapGetters} from 'vuex';

  export default {
    props: {
      name: {
        type: String,
        required: true
      }
    },

    mixins: [momentMixin],

    computed: {
      ...mapGetters({
        filtersValues: FILTERS_GET_VALUES
      }),

      dataQuery() {
        return {
          ...this.filtersValues,
          name: this.name
        };
      }
    },

    components: {
      MarketAnalysis
    }
  };
</script>

<style lang="scss" scoped>
</style>
